goog.provide("shadow.js.shim.module$$mui$material$ListItemAvatar$default");
shadow.js.shim.module$$mui$material$ListItemAvatar$default = shadow.js.shim.module$$mui$material$ListItemAvatar.default;
